"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getObjectValues = void 0;
exports.getObjectValues = Object.values;
